import cn from 'classnames';
import { DashboardJobsiteTile } from 'containers/dashboard/components/DashboardJobsiteTile';
import { DashboardTabProps } from 'containers/dashboard/types';
import React from 'react';

export function DashboardTab({
  jobsites,
  asList,
}: DashboardTabProps): React.ReactElement {
  return (
    <div
      className={cn(
        'odin-grid odin-grid-cols-1 md:odin-grid-cols-2 xl:odin-grid-cols-3 2xl:odin-grid-cols-4',
        asList ? 'odin-gap-4' : 'odin-gap-6',
      )}
    >
      {jobsites.map((j) => {
        return (
          <div
            className={cn(
              'odin-flex odin-justify-center odin-w-full',
              asList && 'odin-col-span-4',
            )}
            key={`wrap-${j.jobsiteId}`}
          >
            <DashboardJobsiteTile
              jobsite={j}
              asListRow={asList}
              key={j.jobsiteId}
            />
          </div>
        );
      })}
    </div>
  );
}
